
  export const environment = {
    production: true,
    apiUrl: 'https://azemeisgiorapi.azurewebsites.net/api',
    functionsUrl: 'https://azemeisgior.azurewebsites.net/api',
    hide6fAppData: true,
    hideNews: true,
    mapId: 'f33257edfefa7f3a'
  };